module.exports = __webpack_public_path__ + "media/bootstrap-icons/geo-alt-fill-8947352b.svg";